import script from "./EditUserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserPage.vue?vue&type=script&setup=true&lang=js"

import "./EditUserPage.vue?vue&type=style&index=0&id=bf521308&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf521308"]])

export default __exports__